import { ElMessage } from "element-plus";
import WalletFunc from "./wallet";
import WalletConnection from "./walletconnect";
import { rootFontSize, pc_uiWidth, mobile_uiWidth } from "./config";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();
export const debugToWindow = (key, value) => {
  if (!globalThis.__debug) globalThis.__debug = {};
  globalThis.__debug[key] = value;
};

// 自定义一个序列化方法，主要是为了处理bigInt
export const serialize = (obj) => {
  const replacer = (k, v) => {
    return typeof v === "bigint" ? v.toString() : v;
  };
  return JSON.stringify(obj, replacer);
};

// 把walletConnection挂载到window上
export const setWalletConnection = () => {
  if (!globalThis.walletConnection)
    globalThis.walletConnection = new WalletConnection();
};

export const setWallet = () => {
  if (!globalThis.wallet) globalThis.Wallet = new WalletFunc();
};

export const removeWalletConnection = () => {
  delete globalThis.walletConnection;
};

/**
 * 函数功能：get请求url拼接参数
 *
 * @param {string} url --路由url字符串
 * @param {Object} data --get请求的参数
 *
 * @returns {string} --get请求完整url
 */

export const concatQuery = (url, data) => {
  let paramsArray = [];
  Object.keys(data).forEach((key) => {
    if (!data[key]) return; // 如果value为null值，那么拼接时候不拼这个值
    return paramsArray.push(key + "=" + data[key]);
  });
  url = paramsArray.length === 0 ? url : (url += "?" + paramsArray.join("&"));
  return url;
};

// 用于处理内联样式
export const px2rem = (px) => {
  return parseFloat(px) / rootFontSize + "rem";
};
// 输入一段字符串，输出ascii序列
export const stringToAscii = (str) => {
  return str.split("").map((char) => char.charCodeAt());
};

export const hex2rgb = (hex) => {
  if (!hex && hex?.length !== 7) return;
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
};

export const rgb2hex = (rgb) => {
  return (
    "#" +
    ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1)
  );
};

export const rgbLightOrDark = (rgb) => {
  if (!rgb) return;
  return 0.213 * rgb[0] + 0.715 * rgb[1] + 0.072 * rgb[2] < 255 / 2;
};

//复制到剪切板
export const copyToCliboard = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
    ElMessage({
      message: "copy successfully",
      type: "success",
      customClass: "messageIndex",
      duration: 2000,
    });
  } else {
    alert("浏览器版本过低，不能复制");
  }
};

export const copyLink = () => {
  copyToCliboard(globalThis.location.href);
};

/**
 *
 * 保留字符串的开头和结尾的一部分，中间用省略号
 *
 * @param {*} str 需要实现省略的字符串
 * @param {*} startNum 所保留字符串开头的量
 * @param {*} endNum 所保留字符串结尾的量
 * @returns
 */
export const stringOmit = (str, startNum = 0, endNum = 0) => {
  if (!str) return "--";
  const firstHalfString = str.substring(0, startNum);
  const lastHalfString = str.substring(str.length - endNum);
  return `${firstHalfString}...${lastHalfString}`;
};

export const randomCoding = (num) => {
  //创建26个字母数组
  var arr = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0",
  ];
  let idvalue = "";
  for (var i = 0; i < num; i++) {
    idvalue += arr[Math.floor(Math.random() * 36)];
  }
  return idvalue;
};

// js判断是否为移动端
export const isMobile = () => {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|Mobi)/i
  );
};

// 设置设计稿基础宽度
export const setRootSize = (uiWidth = pc_uiWidth) => {
  const baseSize = rootFontSize;
  function setRem() {
    const scale =
      document.documentElement.clientWidth /
      (isMobile() ? mobile_uiWidth : uiWidth); // 设计稿宽度1920，勿改
    document.documentElement.style.fontSize =
      baseSize * Math.min(scale, 2) + "px";
  }
  setRem();
  window.onresize = function () {
    setRem();
  };
};

export const openTwitter = () => {
  window.open("https://twitter.com/BeArt_RWA");
};

export const openTelegram = () => {
  window.open("https://t.me/+iWxNKmUr3YE2OWI1");
};

export const openMedium = () => {
  window.open("https://medium.com/@beartrwa");
};

export const openDiscord = () => {
  window.open("https://discord.gg/tuY4dt6HwF");
};

export const openReddit = () => {
  window.open("https://www.reddit.com/r/BeArtLounge");
};

/**
 * @description: 乘以精度
 */
export function multiplyDecimals(number, power) {
  return number * Math.pow(10, power);
}

/**
 * @description: 除以精度
 */
export function divideDecimals(number, power, flag = false) {
  const res = number / Math.pow(10, power);
  if (flag) return res;
  return formatNumber3(res);
}

/**
 * @description: 千位数分割
 */
export const formatNumber3 = (number) => {
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 10,
  }).format(number);
};

// slice 任意位数分割
export function formatNumber4(num, length = 4, char = ",") {
  let result = "";
  let nums = num.toString().split(".");
  let int = nums[0];
  let decmial = nums[1] ? "." + nums[1] : "";
  while (int.length > length) {
    result = char + int.slice(-length) + result;
    int = int.slice(0, int.length - length);
  }
  if (int) {
    result = int + result;
  }
  return result + decmial;
}

export function handleUtcTime(time) {
  return dayjs(time).format("DD/MM/YY hh:mm:ss");
}



export const open1 = () => {
  window.open("https://mixin.one/codes/58faf989-ddd3-4ef6-b0e2-b90d74a8e408");
};

export const open2 = () => {
  window.open("https://medium.com/@atlasvault");
};
export const open3 = () => {
  window.open("https://t.me/AtlasVault_Hub");
};
export const open4 = () => {
  window.open("https://x.com/beart_rwa");
};